// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import AdministrativeAreasController from "./administrative_areas_controller.js"
application.register("administrative-areas", AdministrativeAreasController)

import CharacterCounterController from "./character_counter_controller.js"
application.register("character-counter", CharacterCounterController)

import CheckboxLimitController from "./checkbox_limit_controller.js"
application.register("checkbox-limit", CheckboxLimitController)

import FieldToggleController from "./field_toggle_controller.js"
application.register("field-toggle", FieldToggleController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import PushStateController from "./push_state_controller.js"
application.register("push-state", PushStateController)

import VideoLoadController from "./video_load_controller.js"
application.register("video-load", VideoLoadController)

import VideoSearchController from "./video_search_controller.js"
application.register("video-search", VideoSearchController)
